import Configuration from '../configuration';
import http from "./http-client";

class OutagesReportService {

  dummyData=
  {
    "data":
    {
      "timestamp": "2020-11-03 08:19:17.654+0000",
      "message": "Successfully retrieved Outages.",
      "responseCode": "200",
      "return": {
        "Outages": {
          "Outage": [
            {
              "element": "830L outage",
              "affectedIntertieOrFlowgate": [
                {
                  "displayValue": "SK",
                  "affectedLines": [
                    "SK"
                  ]
                }
              ],
              "fromInLocalTime": "2025-09-16 11:00",
              "toInLocalTime": ""
            },
            {
              "element": "840s McNeil Outage",
              "affectedIntertieOrFlowgate": [
                {
                  "displayValue": "SK",
                  "affectedLines": [
                    "SK"
                  ]
                }
              ],
              "fromInLocalTime": "2025-09-16 11:00",
              "toInLocalTime": ""
            },
            {
              "element": "MATL Outage",
              "affectedIntertieOrFlowgate": [
                {
                  "displayValue": "MATL",
                  "affectedLines": [
                    "MATL"
                  ]
                },
                {
                  "displayValue": "BC",
                  "affectedLines": [
                    "BC"
                  ]
                }
              ],
              "fromInLocalTime": "",
              "toInLocalTime": "2025-09-28 17:00"
            },
            {
              "element": "1201L outage",
              "affectedIntertieOrFlowgate": [
                {
                  "displayValue": "BC/MATL",
                  "affectedLines": [
                    "BC_MATL"
                  ]
                },
                {
                  "displayValue": "MATL",
                  "affectedLines": [
                    "MATL"
                  ]
                },
                {
                  "displayValue": "BC",
                  "affectedLines": [
                    "BC"
                  ]
                }
              ],
              "fromInLocalTime": "2025-09-19 07:00",
              "toInLocalTime": "2025-09-28 17:00"
            },
            {
              "element": "Path 1 Outage - AIES Islanding",
              "affectedIntertieOrFlowgate": [
                {
                  "displayValue": "BC/MATL",
                  "affectedLines": [
                    "BC_MATL"
                  ]
                },
                {
                  "displayValue": "MATL",
                  "affectedLines": [
                    "MATL"
                  ]
                },
                {
                  "displayValue": "BC",
                  "affectedLines": [
                    "BC"
                  ]
                }
              ],
              "fromInLocalTime": "2025-09-19 07:00",
              "toInLocalTime": "2025-09-28 17:00"
            }
          ]
        }
      }
    }
}

retrieveData(fromDate,he) {
    if(Configuration.IS_DUMMY_DATA)
    {
      var data = Promise.resolve(this.dummyData);
      return  data.then(function(value) {
           return value;
      });
    } else
    {
      return http.get("outage/",{"params":{
        "he":he,
        "startDate":fromDate
      }});
    }
  }
}

export default OutagesReportService;